<template>
  <div class="home my-5">
		<v-container v-if="dataLoaded" class="wrapper">
      <v-banner
        v-if="invoiceSummary['amount-unlocked-euro'] || invoiceSummary['amount-unlocked-dollar'] || invoiceSummary['amount-locked-euro'] || invoiceSummary['amount-locked-dollar']"
        class="d-flex flex-xl-row flex-lg-row flex-column justify-center px-xl-16 px-lg-16 mb-8"
      >
        <v-icon
          slot="icon"
          color="primary"
          size="36"
        >
          mdi-file-document-edit
        </v-icon>
          <p v-if="invoiceSummary['amount-unlocked-euro'] || invoiceSummary['amount-unlocked-dollar']">{{$t("intranet.sales.unlockedMoney")}} {{invoiceSummary["amount-unlocked-euro"] ? invoiceSummary["amount-unlocked-euro"] + " €" : invoiceSummary["amount-unlocked-dollar"] + " $"}}</p>
          <p v-if="invoiceSummary['amount-locked-euro'] || invoiceSummary['amount-locked-dollar']">{{$t("intranet.sales.lockedMoney")}} {{invoiceSummary["amount-locked-euro"] ? invoiceSummary["amount-locked-euro"] + " €" : invoiceSummary["amount-locked-dollar"] + " $"}} {{$t("intranet.sales.unlockedAt")}} {{new Date(invoiceSummary["will-unlock-at"]).toLocaleDateString("fr-FR")}}</p> 
        <template v-slot:actions>
          <v-btn
            v-if="invoiceSummary['amount-locked-euro'] || invoiceSummary['amount-locked-dollar']"
            class="mb-2"
            outlined 
            :to="{ name:'InvoiceCreate', params: {id: $route.params.id} }"
          >
          {{$t("intranet.sales.declare")}}
          </v-btn>
          <v-btn
            v-else
            color="primary"
            icon
            to="/authenticated/invoices"
          >
            <v-icon large>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </template>
      </v-banner>
			<div class="body">
				<div class="header">
					<v-col class="discount-code d-flex flex-column align-center mt-4">
            <p class="ma-1">{{$t("intranet.sales.discountCode")}}</p> <h2 class="ma-1">{{$route.params.discountCode}}</h2>
					</v-col>
				</div>
        <div class="d-flex flex-xl-column flex-lg-column flex-column-reverse my-10">
          <v-col class="component my-5">
            <AveineSaleCharts class="component" :APIbaseURL="APIbaseURL" :ambassadorId="$route.params.id" :discountCode="$route.params.discountCode" :selectedCurrency="selectedCurrency" />
          </v-col>
          <v-col class="component my-5">
            <h1 class="my-5">{{$t("intranet.title.page.sales.declaredSales")}}</h1>
            <AveineSaleDetails class="component" :APIbaseURL="APIbaseURL" :selectedCurrency="selectedCurrency" :monthSalesNumber="monthSalesNumber" :yearSalesNumber="yearSalesNumber" :totalSalesNumber="totalSalesNumber" :totalIncome="totalIncome" :pendingIncome="pendingIncome" :adminMode="true"/>
          </v-col>
        </div>
			</div>
		</v-container>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineSaleCharts, AveineSaleDetails } from 'aveine-sale'
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      orders: [],
			/**
			 * Represent the different currencies
			 *
			 * @type {Object[]}
			 */
			currencies: [
				{
					name: 'Euros',
					code: 'EUR',
				},
				{
					name: 'Dollars',
					code: 'USD',
				}
      ],
      /**
       * The selected currency
       * 
       * @type {String}
       */
      selectedCurrency: null,
      /**
       * Flag to know if page data has been loaded
       * 
       * @type {boolean}
       */
      dataLoaded: false,
      /**
       * Store monthly sale number by product
       * 
       * @type {Object}
       */
      monthSalesNumber: Object,
      /**
       * Store yearly sale number by product
       * 
       * @type {Object}
       */
      yearSalesNumber: Object,
      /**
       * Store total sale number by product
       * 
       * @type {Object}
       */
      totalSalesNumber: Object,
      /**
       * Store the total income the current user has grossed
       * 
       * @type {Object}
       */
      totalIncome: Object,
      /**
       * Store the total pending income that hasn't been declared or payed yet
       * 
       * @type {Object}
       */
      pendingIncome: Object,
      /**
       * Store the invoicing information of the current user
       * 
       * @type {Object}
       */
      invoiceSummary: Object,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Read',
  components: {
    AveineSaleCharts,
    AveineSaleDetails
  },
  async created() {
    try {
      this.authToken = await this.$auth.getTokenSilently();

      this.selectedCurrency = this.currencies[0].code;
      
      let startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('.')[0]+"Z";
      let endDate =  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString().split('.')[0]+"Z";

      let fetchMonthSummary = await fetch(`${process.env.VUE_APP_API_HOST}/orders/ambassadors/${this.$route.params.id}/data/${startDate}/${endDate}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ` + this.authToken
        }
      })

      let monthSummary = await fetchMonthSummary.json();
      this.monthSalesNumber = {aveineAmount: monthSummary["total-aveine"], essentielAmount: monthSummary["total-estl"]}
      
      let currentYear = new Date().getFullYear();

      let fetchYearSummary = await fetch(`${process.env.VUE_APP_API_HOST}/orders/ambassadors/${this.$route.params.id}/data/${currentYear}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ` + this.authToken
        }
      })

      let yearSummary = await fetchYearSummary.json();
      this.yearSalesNumber = {aveineAmount: yearSummary["total-aveine"], essentielAmount: yearSummary["total-estl"]}

      let fetchTotalSummary = await fetch(`${process.env.VUE_APP_API_HOST}/orders/ambassadors/${this.$route.params.id}/summary`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ` + this.authToken
        }
      })

      const invoiceSummaryJson = await fetchTotalSummary.json();
      this.invoiceSummary = invoiceSummaryJson.meta;
      this.totalSalesNumber = {aveineAmount: this.invoiceSummary["total-aveine-amount"], essentielAmount: this.invoiceSummary["total-estl-amount"]}
      this.totalIncome = { 
        USD: parseInt(this.invoiceSummary["amount-paid-dollar"]),
        EUR: parseInt(this.invoiceSummary["amount-paid-euro"])
      }

      this.pendingIncome = {
        USD: parseInt(this.invoiceSummary["amount-locked-dollar"]) + parseInt(this.invoiceSummary["amount-unlocked-dollar"]),
        EUR: parseInt(this.invoiceSummary["amount-locked-euro"]) + parseInt(this.invoiceSummary["amount-unlocked-euro"]),
      }

      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  },
  method: {
        /**
     * Export file containinig total sales or the choosen time period sales if specified
     *  
     */
    async exportSales(startDate, endDate) {
      this.salesExportInProgress = true;
      let authToken = await this.$auth.getTokenSilently();
      let query = `${process.env.VUE_APP_API_HOST}/orders/export`;

      query+= `?filter[discount-code]=${this.$route.params.discountCode}`

      if (this.selectedTab == 0) {
        if (startDate && endDate) {
          query += `&begin=${new Date(this.startDate).toISOString()}&end=${new Date(this.endDate).toISOString()}`;
        }
      } else if (this.selectedTab == 1) {
        query += `&begin=${new Date(`${this.selectedYear}-1-1`).toISOString()}&end=${new Date(`${this.selectedYear}-12-31`).toISOString()}`;
      }

      let fetchSalesExport = await fetch(query, {
        method: "POST",
        body: JSON.stringify({}),
        headers: {
          "Authorization": `Bearer ${authToken}`
      }
      })
      this.salesExportInProgress = false;
      let salesExport = await fetchSalesExport.json();
      window.open(salesExport.meta.uri);
    }
  }
}
</script>

<style lang="scss" scoped>
  img.currency-image {
    width: 15px;
  }
  div.wrapper {
    h1 {
      color: #1A2A4B;
      font-size: 1.6em;
    }
  
    div.body {
      background-color: #F8F8F8;
  
      div.header {
        width: 20vw;
        margin: auto;
  
        div.discount-code,
        div.currency {
          text-align: center;
        }
  
        div.discount-code {
          margin-bottom: 2vh;
          span {
            color: #E4012D;
            font-size: 2em;
          }
          @media only screen and (max-width: 600px) {
            span {
              margin-right: 35px;
            }
          }
        }
  
        div.currency {
          md-input-container {
            margin: 0;
            padding: 0;
            height: 3vh;
            font-size: 1em;
          }
        }
      }
  
  
      div.component {
        h2 {
          font-size: 1em;
        }
      }
    }
  }
</style>

